import { useSecondPostSurvey } from 'src/components/communitySurvey/hooks/useSecondPostSurvey'
import { Radio } from 'src/pages/Migration/migration.styles'
import { useUser } from 'src/hook/useUser'
import { ThemeMode } from '@hotmart/space-lib/dist/styles/themes/enum'
import i18n from 'src/i18n'
import Button from '@hotmart/space-lib/dist/components/button'
import { faArrowRight } from '@fortawesome/pro-light-svg-icons/faArrowRight'
import Icon from '@hotmart/space-lib/dist/components/icon'
import {
  SECOND_POST_EXPERIENCE_OPTIONS,
  PROGRESS_BAR_VALUE_SECOND_POST_MOST_LIKED_STEP,
  Step,
  PROGRESS_BAR_VALUE_SECOND_POST_IMPROVEMENT_FROM_BEGIN_STEP
} from '../../secondPostSurvey.constants'

const SecondPostExperience = ({ navigateToNextStep, setProgressBarValue, onCloseModal }) => {
  const { theme } = useUser()
  const { secondPostExperienceValue, setSecondPostExperienceValue, THIRD_POST_SURVEY_KEY } =
    useSecondPostSurvey()

  const handleClickNextStep = () => {
    navigateToNextStep(secondPostExperienceValue?.step_to_go)

    if (secondPostExperienceValue?.step_to_go === Step.SecondPostMostLiked) {
      setProgressBarValue(PROGRESS_BAR_VALUE_SECOND_POST_MOST_LIKED_STEP)

      return
    }

    setProgressBarValue(PROGRESS_BAR_VALUE_SECOND_POST_IMPROVEMENT_FROM_BEGIN_STEP)
  }

  const handleClose = () => {
    onCloseModal()

    localStorage.setItem(THIRD_POST_SURVEY_KEY, 'true')
  }

  return (
    <>
      <h1 className="_text-3 _font-weight-light _text-gray-700 _mb-6">
        {i18n.t('community_survey.second_post.experience.title')}
      </h1>

      {SECOND_POST_EXPERIENCE_OPTIONS.map((option) => (
        <div key={option.value}>
          <Radio
            id={String(option.value)}
            name={option.label}
            aria-label={option.label}
            className="_text-gray-600 _text-2 _font-weight _mb-4"
            label={i18n.t(`${option.label}`)}
            value={option.value}
            checked={option.value === secondPostExperienceValue?.value}
            onChange={() => setSecondPostExperienceValue(option)}
            $isDarkMode={theme === ThemeMode.DARK}
          />
        </div>
      ))}
      <div className="_mt-7 _d-flex _justify-content-end _align-items-center">
        <Button variation="secondary" onClick={handleClose}>
          {i18n.t('community_survey.buttons.cancel_survey')}
        </Button>
        <Button
          className="_ml-3"
          variation="primary"
          onClick={handleClickNextStep}
          disabled={!secondPostExperienceValue}
        >
          {i18n.t('community_survey.buttons.next_step')}
          <Icon className="_ml-2" icon={faArrowRight} />
        </Button>
      </div>
    </>
  )
}

export default SecondPostExperience
